import 'what-input';
import './frame-busting';
import './tailwind.scss';

import Vue from 'vue';
import App from './App.vue';
import Inline from 'src/components/content/Inline.vue';
import createRouter from './views/router';
import lang from '@cognitoforms/element-ui/lib/locale/lang/en';
import locale from '@cognitoforms/element-ui/lib/locale';
import longPress from 'src/utilities/long-press';
import clickOutside from 'src/utilities/clickOutside';
import VueProgressBar from 'vue-progressbar';
import { getCssVarValue } from '@cognitoforms/utils/css-helper';

import VueRouter from 'vue-router';
import VueGtag from 'vue-gtag';
import VueMeta from 'vue-meta';
import VueCookies from 'vue-cookies';
import PortalVue from 'portal-vue';

import { isPrerender } from '@cognitoforms/utils/utilities';
import { disableTransitions } from './disable-transitions';
import { CognitoConfiguration } from '@cognitoforms/utils/clientside-configuration';
import { reportReferral } from '@cognitoforms/api/services/referral';

export default function createApp({ amp = false }) {
	const isProd = process.env.NODE_ENV === 'production';

	Vue.config.productionTip = false;
	Vue.config.ignoredElements = [/^lottie-player$/];

	Vue.config.lang = 'en';
	locale.use(lang);

	Vue.filter('usd', value => {
		return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
	});

	Vue.filter('number', value => {
		return value.toLocaleString('en-US');
	});

	Vue.directive('click-outside', clickOutside);
	Vue.directive('long-press', longPress);

	Vue.use(VueProgressBar, {
		color: getCssVarValue('--accent-5'), // thetis
		failedColor: getCssVarValue('--alert-6'), // blossom
		thickness: '3px'
	});

	// router
	Vue.use(VueRouter);
	const router = createRouter();

	// head
	Vue.use(VueMeta, {
		keyName: 'head',
		tagIDKeyName: 'id'
	});

	Vue.use(VueCookies);
	Vue.use(PortalVue);

	if (!isPrerender()) {
		reportReferral();

		Vue.use(VueGtag, {
			config: {
				id: CognitoConfiguration.GoogleAnalyticsId || 'G-TTBCW8BFKB'
			},
			pageTrackerTemplate(to) {
				return {
					page_title: to.meta.title,
					send_to: to.meta.auth === 'required' ?
						(CognitoConfiguration.AdminGoogleAnalyticsId || 'G-TTBCW8BFKB') :
						(CognitoConfiguration.GoogleAnalyticsId || 'G-TTBCW8BFKB')
				};
			},
			bootstrap: false
		}, router);
	}
	else {
		disableTransitions();
	}

	// add global $amp property to all components
	Vue.prototype.$amp = amp;

	Vue.component('Inline', Inline);

	const app = new Vue({
		router,
		render: h => h(App)
	});

	Vue.config.performance = !isProd;
	Vue.config.devtools = !isProd;

	return { app, router };
}

declare global {
	interface Window {
		$cookies: typeof VueCookies.VueCookies;
	}
}